const size = [
  {
    display: 4,
    size: 4,
  },
  {
    display: 4.5,
    size: 4.5,
  },
  {
    display: 5,
    size: 5,
  },
  {
    display: 5.5,
    size: 5.5,
  },
  {
    display: 6,
    size: 6,
  },
  {
    display: 6.5,
    size: 6.5,
  },
  {
    display: 7,
    size: 7,
  },
  {
    display: 7.5,
    size: 7.5,
  },
  {
    display: 8,
    size: 8,
  },
  {
    display: 8.5,
    size: 8.5,
  },
  {
    display: 9,
    size: 9,
  },
  {
    display: 9.5,
    size: 9.5,
  },
  {
    display: 10,
    size: 10,
  },
  {
    display: 10.5,
    size: 10.5,
  },
  {
    display: 11,
    size: 11,
  },
  {
    display: 11.5,
    size: 11.5,
  },
  {
    display: 12,
    size: 12,
  },
  {
    display: 12.5,
    size: 12.5,
  },
];

export default size;
